import {
  TyckaConfig,
  ProductFieldsResponse,
  TransactionDataResponse,
  FieldsFormData,
  TransactionData,
  AuthorData,
  CreateReviewResponse,
  RelatedProductsResponse,
} from '../types';

import { createReview, getProductFields, getTransactionData, getRelatedProductsData } from './gql';

export class TyckaGraphqlClient {
  private teamId: string;
  private projectId: string;
  private graphqlUrl: string;
  private graphqlEndpoint: string;

  constructor(config: TyckaConfig) {
    this.teamId = config.teamId;
    this.projectId = config.projectId;
    this.graphqlUrl = config.graphqlUrl;
    this.graphqlEndpoint = `${this.graphqlUrl}/${this.teamId}_${this.projectId}/graphql`;
  }

  public async fetchProductFields() {
    const response = await this.graphqlClient(getProductFields());
    return ((await response.json()) as ProductFieldsResponse).data.__type;
  }

  public async fetchTransactionData(
    fields: string[],
    itemId: string,
    transactionId: string,
    secret: string
  ) {
    const response = await this.graphqlClient(
      getTransactionData(fields, itemId, transactionId, secret)
    );
    return ((await response.json()) as TransactionDataResponse).data;
  }

  public async fetchRelatedProductsData(
    fields: string[],
    itemIds: string[],
  ) {
    const response = await this.graphqlClient(
      getRelatedProductsData(fields, itemIds)
    );
    return ((await response.json()) as RelatedProductsResponse).data;
  }

  public async createReview(
    formData: FieldsFormData,
    transactionData: TransactionData,
    authorData: AuthorData
  ) {
    const response = await this.graphqlClient(
      createReview(formData, transactionData, authorData)
    );
    return ((await response.json()) as CreateReviewResponse).data;
  }

  private async graphqlClient(body: string) {
    return fetch(this.graphqlEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: body,
      }),
    });
  }
}
